import cx from 'classnames'
import { useButton } from '@react-aria/button'
import { CSSProperties, useRef } from 'react'
import Styles from './ThemeHuePicker.module.scss'

import { HueSwatchProps, ThemeHuePickerProps } from './Types'

const HueSwatch = ({ isSelected = false, color, onPress }: HueSwatchProps) => {
  const ref = useRef<HTMLButtonElement>(null)
  const { buttonProps } = useButton(
    {
      'aria-label': color,
      onPress: () => onPress?.(color),
    },
    ref,
  )

  return (
    <div
      className={cx(Styles.hueSwatch, {
        [Styles.selected]: isSelected,
      })}
    >
      <button
        {...buttonProps}
        className={cx(Styles.hueSwatchWell)}
        style={{ '--swatch-color': color } as CSSProperties}
        ref={ref}
      />
    </div>
  )
}

const ThemeHuePicker = ({ className, colors, value, onChange }: ThemeHuePickerProps) => {
  return (
    <div className={cx(Styles.picker, className)}>
      {colors.map((color) => (
        <HueSwatch key={color} color={color} onPress={onChange} isSelected={value === color} />
      ))}
    </div>
  )
}

export { ThemeHuePicker }
